import CareProfiles from './CareProfiles';
import CareProfilesWidget from './CareProfilesWidget';

export { CareProfilesWidget };
export default CareProfiles;
